import { BibleVerse } from "../bible-verse/types";

export interface Recipient {
  id: number;
  name: string;
  avatar: string;
}


export type AnniversaryOccasion = {
  
  id: string
  user: User;
  type: "birthday" | "wedding" | "baptism" | "communion";
  date: string;
  years: number
  message: string
  selectedWhatsappTemplate?: WhatsAppTemplate
  headerParameters?: Record<string, any>
  bodyParameters?: Record<string, any>
  selectedVerse?: BibleVerse
};
// export interface Zone {
//     id: string;
//     name: string;
//     areas: string[];
// }



// export interface User {
//   id: number;
//   name: string;
//   email: string;
//   zone: string;
//   area: string;
//   status: string;
//   avatar: string;
// }
export interface User {
  id: number;
  name: string;
  email: string;
  phone: string;
  avatar: string;
  birthDate: string;
  weddingDate?: string;
  baptismDate?: string | null;
  firstCommunionDate?: string | null;
  gender: 'male' | 'female';
  zone: Zone;
  department?: string;
  designation?: string;
  address: string;
  status?: string;
  is_whatsapp_enabled: boolean;
}



// export interface User {
//   id: number;
//   name: string;
//   phone: string;
//   address: string;
//   status?: string;
//   avatar?: string
//   is_whatsapp_enabled: boolean;
//   zone: Zone;
// }

// export interface Zone {
//     id: string;
//     name: string;
//     areas: string[];
//     selected: boolean;
// } 

// export interface Zone {
//   id: number;
//   zone_name: string;
//   users: string[];
//   leader: string | null;
//    selected: boolean;
// }

export interface Zone {
  id: number;
  zone_name: string;
  users: string[];
  leader?: Leader;
  selected?: boolean;
}
interface Leader {
  id: number;
  name: string;
  image_path: string | null;
  phone: string;
  address: string;
  is_visitor: boolean;
  member_type: string;
  is_leader: boolean;
  is_delete: boolean;
  is_request_send: boolean;
  profile: any | null;
}


// export interface WhatsAppTemplate {
//   id: string;
//   name: string;
//   category: string;
//   language: string;
//   components: {
//     type: "HEADER" | "BODY" | "FOOTER" | "BUTTONS";
//     text?: string;
//     format?: "TEXT" | "IMAGE" | "VIDEO" | "DOCUMENT";
//     buttons?: {
//       type: "URL" | "PHONE_NUMBER" | "QUICK_REPLY";
//       text: string;
//       url?: string;
//       phone_number?: string;
//     }[];
//   }[];
//   requiredFields: {
//     name: string;
//     type: "text" | "number" | "date" | "image" | "document";
//     description: string;
//   }[];
// }


// export interface TemplateField {
//   name: string;
//   type: "text" | "number" | "date" | "image" | "document";
//   description: string;
// }

export interface WhatsAppTemplate {
  id: string;
  name: string;
  category: string;
  language: string;
  status: string;
  parameter_format: 'NAMED' | 'POSITIONAL';
  components: {
    type: 'HEADER' | 'BODY' | 'FOOTER' | 'BUTTONS';
    text?: string;
    format?: 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT';
    example?: {
      header_text_named_params?: Array<{
        param_name: string;
        example: string;
      }>;
      body_text_named_params?: Array<{
        param_name: string;
        example: string;
      }>;
      header_text?: string[];
      body_text?: string[][];
    };
    buttons?: {
      type: 'URL' | 'PHONE_NUMBER' | 'QUICK_REPLY';
      text: string;
      url?: string;
      phone_number?: string;
    }[];
  }[];
  requiredFields: {
    name: string;
    type: 'text' | 'number' | 'date' | 'image' | 'document';
    description: string;
    example?: string;
  }[];
}

export type MessageRequest = {

  whatsapp_message: {
    template_name: string,
    header_parameters: { [k: string]: string } | string[]
    body_parameters: { [k: string]: string } | string[]
    // footer_parameters: { [k: string]: string } | string[]

  }

  sms_message: {
    use_whatsapp_template: boolean,
    text?: string
  }

  recipient_member_ids: number[]
  zone_ids: number[]
  group_ids: number[]
  team_ids: number[]

  channels: {
    whatsapp: boolean
    sms: boolean
  }

}




// export type GroupMessageRequest = MessageRequest & {
//   type: BatchType.GROUP
//   recipient_member_ids: number[]
//   zone_ids: number[]
// }

// export type AnniversaryMessageRequest = MessageRequest & {

//   type: BatchType.INDIVIDUALIZED
//   recipient_member_id: number
//   occassion: string
//   occassion_date: Date

// } 


export type AnniversaryMessageRequest = {

  whatsapp_message: {
    template_name: string,
    header_parameters: { [k: string]: string } | string[]
    body_parameters: { [k: string]: string } | string[]
    // footer_parameters: { [k: string]: string } | string[]

  }

  sms_message: {
    use_whatsapp_template: boolean,
    text?: string
  }

  // recipient_member_ids: number[]
  // zone_ids: number[]
  recipient_member_id: number
  occassion: string
  occassion_date: Date

  channels: {
    whatsapp: boolean
    sms: boolean
  }

}


export interface MessageChannel {
  status: BatchStatus
  error?: string;
  sentAt?: Date;
  deliveredAt?: Date;
}


export interface MessageRecipient {
  id: number;
  name: string;
  phoneNumber: string;
  status: BatchStatus
  channels: {
    whatsapp?: MessageChannel;
    sms?: MessageChannel;
  };
}

export enum BatchStatus {
  'pending', 'progress', 'sent', 'delivered', 'failed', 'completed'
}

export interface MessageContent {
  header?: string;
  body: string;
  footer?: string;
  buttons?: Array<{ text: string; url?: string }>;
}

export enum BatchType {
  GROUP, INDIVIDUALIZED
}

export type MessageTransaction = {
  id: number;
  templateName: string;
  message: MessageRequest;
  recipients: MessageRecipient[];
  template: WhatsAppTemplate;
  status: BatchStatus;
  progress: number;
  totalRecipients: number;
  successfulRecipients: string[];
  batchRecipients: BatchJobRecipient[];
  createdAt: Date;
  updatedAt: Date;
  channels: string[];
  is_whatsapp_enabled: boolean;
  content: MessageContent;
  batchType: BatchType

}

export type BatchJobRecipient = {
  id: number;
  phoneNumber: string;
  member_id: number;
  isWhatsapp: boolean;
  status: BatchStatus;
  error_message: string | null;
  retryCount: number;
  sentAt: Date;
  deliveredAt: Date;
  createdAt: Date;
  updatedAt: Date;
  member: { name: string }
}


// interface MessageTransaction {
//   id: string;
//   templateName: string;
//   status: 'pending' | 'processing' | 'completed' | 'failed';
//   progress: number;
//   totalRecipients: number;
//   successfulRecipients: number;
//   failedRecipients: number;
//   channels: string[];
//   createdAt: Date;
// }


export const getOccasionDisplayName = (type: string) => {
  switch (type) {
    case 'birthday':
      return 'Birthday';
    case 'wedding':
      return 'Wedding Anniversary';
    case 'baptism':
      return 'Baptism Anniversary';
    case 'communion':
      return 'Communion Anniversary';

    default:
      return type;
  }
};